import React from 'react';

import { formatNumber, formatPercent } from '../../../utils';
import { FREE_MONEY_COLOR, OTHER_POSITIONS_COLOR, getPortfolioColor } from '../colors';
import { PiePosition, FREE_MONEY, OTHER_POSITIONS } from '../PieChart';

type Props = {
  positions: PiePosition[];
  activeIndex?: number | null;
  onItemHover?: (index: number | null) => void;
};

export const ChartLegend: React.FC<Props> = ({ positions, activeIndex = null, onItemHover }) => {
  return (
    <div className="chart-legend">
      {positions.map(({ symbol, name, weight, number, currency, avgPrice, lastPrice }, key) => {
        const isActive = activeIndex === null || activeIndex === key;
        const label = name === FREE_MONEY || name === OTHER_POSITIONS ? name : symbol || name || '-';
        const description = name === FREE_MONEY || name === OTHER_POSITIONS || !name || name === symbol ? null : name;
        const hasPositionMeta = name !== FREE_MONEY && name !== OTHER_POSITIONS;
        const quantity =
          typeof number === 'number' && Number.isFinite(number) ? `${formatNumber(number, 0)} шт.` : null;
        const avgPriceLabel =
          typeof avgPrice === 'number' && Number.isFinite(avgPrice)
            ? `ср. ${formatNumber(avgPrice, 4)}${currency ? ` ${currency}` : ''}`
            : null;
        const lastPriceLabel =
          typeof lastPrice === 'number' && Number.isFinite(lastPrice)
            ? `тек. ${formatNumber(lastPrice, 4)}${currency ? ` ${currency}` : ''}`
            : null;
        const meta = hasPositionMeta ? [quantity, avgPriceLabel, lastPriceLabel].filter(Boolean).join(' · ') : null;
        const color =
          name === FREE_MONEY
            ? FREE_MONEY_COLOR
            : name === OTHER_POSITIONS
            ? OTHER_POSITIONS_COLOR
            : getPortfolioColor(key);

        return (
          <div
            key={key}
            className={`chart-legend__item ${activeIndex === key ? 'chart-legend__item--active' : ''} ${
              !isActive ? 'chart-legend__item--muted' : ''
            }`}
            onMouseEnter={() => onItemHover?.(key)}
            onMouseLeave={() => onItemHover?.(null)}
          >
            <div
              className="chart-legend__color"
              style={{
                backgroundColor: color,
              }}
            />
            <div className="chart-legend__content">
              <div className="chart-legend__row">
                <span className="chart-legend__label">{label}</span>
                <span className="chart-legend__value">{formatPercent(weight)}</span>
              </div>
              {description && <div className="chart-legend__description">{description}</div>}
              {meta && <div className="chart-legend__meta">{meta}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
